// src/app/router/ui/RootRedirect.jsx
import React, { memo, Suspense } from 'react';
import { useAuth } from '@app/providers';
import { PageLoader } from './PageLoader';
import { HomePage } from '../config';

export const RootRedirect = memo(() => {
  const { loading } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  // Теперь ВСЕ пользователи (и гости, и авторизованные) видят HomePage на корневом пути '/'
  return (
    <Suspense fallback={<PageLoader />}>
      <HomePage />
    </Suspense>
  );
});
